import { render, staticRenderFns } from "./ButtonsService.vue?vue&type=template&id=a67b9fea&scoped=true&"
import script from "./ButtonsService.vue?vue&type=script&lang=js&"
export * from "./ButtonsService.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsService.vue?vue&type=style&index=0&id=a67b9fea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b9fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpeedDial,VTooltip})
